import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs1003',
    ecrans: ['00-2']
});
